// A leaf module with no imports: http.ts imports client-events.ts, and both use it.

export const REDACTED = '[REDACTED]';

// Only true credential params. Kiosk api_key/key params, QR, ticket, download
// and GoPhoto codes, session and visitor IDs, payment IDs and image UUIDs stay:
// they are stored in Postgres and are the join keys from Sentry to the backend.
const SENSITIVE_URL_PARAM_NAMES = new Set([
  'token',
  'access_token',
  'refresh_token',
  'id_token',
  'secret',
  'client_secret',
  'password',
  'signature',
  'x-amz-signature',
  'x-amz-credential',
  'x-amz-security-token',
]);

const SENSITIVE_URL_PARAM_PATTERN =
  /([?&](?:token|access_token|refresh_token|id_token|secret|client_secret|password|signature|x-amz-signature|x-amz-credential|x-amz-security-token)=)[^&#\s]*/gi;

/** Redact the credential params in the text of a URL that does not parse. */
export function redactUrlParams(url: string): string {
  return url.replace(SENSITIVE_URL_PARAM_PATTERN, `$1${REDACTED}`);
}

/** Redact the credential params of a parsed URL, and give the path form for a relative input. */
export function redactParsedUrl(url: URL, relative: boolean): string {
  for (const key of [...url.searchParams.keys()]) {
    if (SENSITIVE_URL_PARAM_NAMES.has(key.toLowerCase())) {
      url.searchParams.set(key, REDACTED);
    }
  }
  return relative ? `${url.pathname}${url.search}${url.hash}` : url.toString();
}
